// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/oil-system.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/oil-system/oil-system.js';

mount([g0]);
